// start:ng42.barrel
import   './address-editor.component';
// end:ng42.barrel

